import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';
import FairTxList from '../FairTxList';

// Модалка продаж точки (точка как продавец): список транзакций по pointId.
export default function PointTxModal({ point, teamName, colorOf, onClose }) {
    return (
        <Modal
            open
            kicker="Точка"
            title={`Продажи · ${point.name || 'Без названия'}`}
            size="xl"
            onClose={onClose}
            footer={<button type="button" className="btn btn-ghost" onClick={onClose}>Закрыть</button>}
        >
            <FairTxList
                queryKey={['fair', 'point-tx', point.id]}
                url={`/api/fair/admin/transaction/list-by-point?pointId=${point.id}`}
                teamName={teamName}
                colorOf={colorOf}
            />
        </Modal>
    );
}

PointTxModal.propTypes = {
    point: PropTypes.object.isRequired,
    teamName: PropTypes.func.isRequired,
    colorOf: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
